// Helpers média centralisés (anti-duplication). Un média servi par le backend est
// un chemin relatif « /api/files/… » ; on lui préfixe l'origine backend. Une URL
// externe (http/https) ou un data-URI est conservée telle quelle.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// URL d'un média : préfixe l'origine backend si chemin relatif.
export const mediaUrl = (u) => (u && u.startsWith("/") ? BACKEND + u : (u || ""));

// URL d'un logo : externe/data-URI conservé, sinon préfixe backend.
export const logoSrc = (l) => (!l ? l : (/^(https?:|data:)/.test(l) ? l : `${BACKEND}${l}`));

export { BACKEND };
